// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   appTitle: 'Intuceo-Ix',
//   apiUrl: 'http://localhost:9200/',
//   defaultIndex: 'pharma'
// };
//apiUrl: 'http://10.0.1.133:9200/'
//apiUrl: 'http://182.72.246.214:9200/',

// pythonUrl:'http://127.0.0.1:8000',   
//pythonUrl:'http://ix.intuceo.com:5500',

export const environment = {
  production: false,
  appTitle: 'Intuceo-Ix',  
  //apiUrl: 'http://10.0.1.133:9200/', 
  apiUrl: 'http://ix.intuceo.com:9200/', 
  pythonUrl:'http://127.0.0.1:8000',   
  //pythonUrl:'http://ix.intuceo.com:5600',  
  defaultIndex: { name: '', title: 'All', fields: [{name: '_index', type: 'keyword', size: 10}]},  
 /*  excludeIndices: [
    'kibana_sample_data_flights', 'farmers_markets_from_usda', 'department', '.monitoring*','.monitoring-kibana-7-2020.08.20','.security-7',
    'kibana_sample_data_ecommerce', '.kibana', 'videos', '.kibana_task_manager','newyork_stock_exchange','.monitoring-es-7-2020.08.20',
    'accidental_drug_related_deaths_2012-2018','netflix_titles','personal_health_records','hacrp','data-oklahoma-health-care-facilities','covid-19_clinical_trails',
    'images','test_docs','videos_folder','us2017_census_tract_data','animal_services_intake_data','clinical_trails','linkedin_data',
    'data-conveniencesupermarkets','data-oklahoma-institutions-of-higher-education"','multimedia_folder','resume_library' ,'capa1','readme','world_university_rankings' ,
    'social_data','data-oklahoma-institutions-of-higher-education' 
  ] */
  excludeIndices: [
    'kibana_sample_data_flights','.monitoring-kibana-7-2020.08.20','.security-7',
    'kibana_sample_data_ecommerce', '.kibana', '.kibana_task_manager','.monitoring-es-7-2020.08.20',
    'images','test_docs','videos_folder', 'multimedia_folder','readme' , 'capa1','clinical_trails','department',
    'harcp'
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
